export const PROJECT_ID = '4840acf160e53b8fc300f551e8ab3393fd186e556b891306f1f26f5d62feb5f6';
export const CONTRACT_ADDRESS = '0x5f92f6E2Ef626679C1fA5539af3A36DaFfCac59b';
export const NCT_CONTRACT_ADDRESS = '0x762d41B44b43a54927A45259F903d369Aa48249f';
export const INFURA_API = 'https://bsc-dataseed4.binance.org';

export const NAME_CHANGE_PRICE = 1830000000000000000000;
export const STARTING_INDEX = 5421;
export const TOTAL_HASHPANDA = 15976;
export const HASHPANDA_URL ='';
export const HASHPANDA_NAME_HISTORY_URL_PREFIX = '';

  